import { type ReactNode, isValidElement } from 'react'
import ReactDOMServer from 'react-dom/server'

export const reactNodeToString = (node: ReactNode): string => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node)
  }

  if (isValidElement(node)) {
    // For React elements, return only the text content, not the full HTML markup
    const htmlString = ReactDOMServer.renderToStaticMarkup(node)

    // Remove HTML tags using regex, leaving only the text content
    return htmlString.replace(/<[^>]*>/g, '')
  }

  return ''
}

export const formatValue = <T extends string | number>(
  value: T,
  primaryFormatter?: (value: T) => ReactNode,
  fallbackFormatter?: (value: T) => ReactNode,
): string => {
  if (primaryFormatter) {
    return reactNodeToString(primaryFormatter(value))
  }

  if (fallbackFormatter) {
    return reactNodeToString(fallbackFormatter(value))
  }

  return String(value)
}
